import axiosClient from 'api/axiosClient';
import queryString from 'query-string';

const costsClaimApi = {
  // ============ CLAIM REQUESTS ============
  getMyClaimsRaw: (params: any) => {
    return axiosClient.get(`/costs-claim?${queryString.stringify(params)}`);
  },
  getAllClaims: (params: any) => {
    return axiosClient.get(`/costs-claim/all?${queryString.stringify(params)}`);
  },
  getClaimDetail: (id: number) => {
    return axiosClient.get(`/costs-claim/${id}`);
  },
  createClaim: (body: any) => {
    return axiosClient.post('/costs-claim', body);
  },
  updateClaim: (id: number, body: any) => {
    return axiosClient.put(`/costs-claim/${id}`, body);
  },
  deleteClaim: (id: number) => {
    return axiosClient.delete(`/costs-claim/${id}`);
  },
  submitClaim: (id: number) => {
    return axiosClient.post(`/costs-claim/${id}/submit`);
  },
  cancelClaim: (id: number) => {
    return axiosClient.post(`/costs-claim/${id}/cancel`);
  },
  revertToDraft: (id: number) => {
    return axiosClient.post(`/costs-claim/${id}/revert-draft`);
  },

  // ============ APPROVAL ============
  approverDecision: (id: number, body: any) => {
    return axiosClient.post(`/costs-claim/${id}/approver-decision`, body);
  },
  financeDecision: (id: number, body: any) => {
    return axiosClient.post(`/costs-claim/${id}/finance-decision`, body);
  },
  markPaid: (id: number, body: any) => {
    return axiosClient.post(`/costs-claim/${id}/mark-paid`, body);
  },

  // ============ ATTACHMENTS ============
  uploadAttachment: (id: number, file: FormData) => {
    return axiosClient.post(`/costs-claim/${id}/attachments`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    } as any);
  },
  getAttachments: (id: number) => {
    return axiosClient.get(`/costs-claim/${id}/attachments`);
  },
  uploadPaymentProof: (id: number, file: FormData) => {
    return axiosClient.post(`/costs-claim/${id}/payment-proof`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    } as any);
  },

  // ============ MASTER DATA ============
  getExpenseTypes: (activeOnly = true) => {
    return axiosClient.get(`/costs-claim/master/expense-types?activeOnly=${activeOnly}`);
  },
  createExpenseType: (body: any) => {
    return axiosClient.post('/costs-claim/master/expense-types', body);
  },
  updateExpenseType: (id: number, body: any) => {
    return axiosClient.put(`/costs-claim/master/expense-types/${id}`, body);
  },
  deleteExpenseType: (id: number) => {
    return axiosClient.delete(`/costs-claim/master/expense-types/${id}`);
  },

  getPaymentMethods: (activeOnly = true) => {
    return axiosClient.get(`/costs-claim/master/payment-methods?activeOnly=${activeOnly}`);
  },
  createPaymentMethod: (body: any) => {
    return axiosClient.post('/costs-claim/master/payment-methods', body);
  },
  updatePaymentMethod: (id: number, body: any) => {
    return axiosClient.put(`/costs-claim/master/payment-methods/${id}`, body);
  },
  deletePaymentMethod: (id: number) => {
    return axiosClient.delete(`/costs-claim/master/payment-methods/${id}`);
  },

  getBanks: (activeOnly = true) => {
    return axiosClient.get(`/costs-claim/master/banks?activeOnly=${activeOnly}`);
  },
  createBank: (body: any) => {
    return axiosClient.post('/costs-claim/master/banks', body);
  },
  updateBank: (id: number, body: any) => {
    return axiosClient.put(`/costs-claim/master/banks/${id}`, body);
  },
  deleteBank: (id: number) => {
    return axiosClient.delete(`/costs-claim/master/banks/${id}`);
  },
};

export default costsClaimApi;
